module.exports = __webpack_public_path__ + "static/media/tec.aa67372b.png";